import {
  Box,
  Button,
  Typography,
  TextField,
  IconButton,
  Paper,
} from "@mui/material";
import { BiDotsHorizontalRounded } from "react-icons/bi";

const PrevIcon = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 22 22">
    <path
      d="M13.5 16L9.5 11L13.5 6"
      stroke="#6366f1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const NextIcon = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 22 22">
    <path
      d="M8.5 6L12.5 11L8.5 16"
      stroke="#6366f1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const gradient = "linear-gradient(135deg, #6366f1 0%, #06b6d4 100%)";

const Pagination = ({
  currentPage,
  setCurrentPage,
  totalPages,
  getPagination,
  itemsPerPageState,
  setItemsPerPageState,
  sortedData,
  totalItems,
}) => {
  return (
    <Paper
      elevation={0}
      className="poppins-font"
      sx={{
        mt: 4,
        // px: { xs: 2, sm: 3 },
        // py: { xs: 2, sm: 2.5 },
        borderRadius: 4,
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      {/* Left: Info + Page size */}
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        <Typography
          fontSize="0.85rem"
          color="text.secondary"
          className="poppins-font"
        >
          Showing{" "}
          <strong>
            {sortedData.length === 0
              ? 0
              : (currentPage - 1) * itemsPerPageState + 1}
          </strong>{" "}
          -{" "}
          <strong>
            {Math.min(currentPage * itemsPerPageState, sortedData.length)}
          </strong>{" "}
          of <strong>{totalItems}</strong>
        </Typography>

        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            fontSize="0.9rem"
            color="text.secondary"
            className="poppins-font"
          >
            Show
          </Typography>
          <TextField
            select
            size="small"
            value={itemsPerPageState}
            onChange={(e) => {
              setItemsPerPageState(Number(e.target.value));
              setCurrentPage(1);
            }}
            SelectProps={{ native: true }}
            sx={{
              minWidth: 70,
              backgroundColor: "#f1f5f9",
              borderRadius: 2,
              "& .MuiInputBase-root": {
                fontSize: "0.8rem", // smaller font
                fontWeight: 600,
              },
            }}
          >
            {[10, 20, 50].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </TextField>
        </Box>
      </Box>

      {/* Right: Pagination controls */}
      <Box display="flex" gap={1.2} alignItems="center" flexWrap="wrap">
        <IconButton
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          sx={{
            backgroundColor: "#f8fafc",
            borderRadius: 2,
            p: 1,
            border: "1px solid #e2e8f0",
            "&:hover": { background: "#eef2ff" },
            opacity: currentPage === 1 ? 0.5 : 1,
          }}
        >
          <PrevIcon />
        </IconButton>

        {getPagination().map((page, idx) =>
          page === "..." ? (
            <BiDotsHorizontalRounded
              key={idx}
              size={22}
              color="#94a3b8"
              style={{ padding: "4px 6px" }}
            />
          ) : (
            <Button
              key={page}
              onClick={() => setCurrentPage(page)}
              variant={currentPage === page ? "contained" : "outlined"}
              className="poppins-font"
              sx={{
                minWidth: 32,
                height: 30,
                borderRadius: 2,
                fontWeight: 600,
                fontSize: "0.8rem", // smaller font
                background: currentPage === page ? gradient : "#ffffff",
                color: currentPage === page ? "#fff" : "#1e293b",
                border: currentPage === page ? "none" : "1px solid #e2e8f0",
                boxShadow:
                  currentPage === page ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
                "&:hover": {
                  background: currentPage === page ? gradient : "#f1f5f9",
                },
              }}
            >
              {page}
            </Button>
          )
        )}

        <IconButton
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          sx={{
            backgroundColor: "#f8fafc",
            borderRadius: 2,
            p: 1,
            border: "1px solid #e2e8f0",
            "&:hover": { background: "#eef2ff" },
            opacity: currentPage === totalPages ? 0.5 : 1,
          }}
        >
          <NextIcon />
        </IconButton>
      </Box>
    </Paper>
  );
};

export default Pagination;
